<template>
  <div class="ihist">
    <table class="ihist__table">
      <thead>
        <tr>
          <th>Nr.</th>
          <th>Cauza</th>
          <th>Data</th>
          <th>Cine</th>
          <th>Stare</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in items" :key="row.id" :class="{ 'is-same': isSame(row) }">
          <td class="ihist__nr">{{ row.approach_number || "—" }}</td>
          <td class="ihist__cause">{{ row.cause || "—" }}</td>
          <td class="ihist__date">{{ row.created_at }}</td>
          <td>{{ row.user }}</td>
          <td><StatusChip :status="row.status" small /></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import StatusChip from "@/components/elements/StatusChip.vue";

// Earlier requests on one physical item (rows of GET /requests/last-execution `history`), newest first.
// Rows with the same cause as the request on screen are marked.
export default {
  name: "ItemRequestHistory",
  components: { StatusChip },
  props: {
    items: { type: Array, default: () => [] },
    sameCauseId: { type: Number, default: null },
  },
  methods: {
    isSame(row) {
      return this.sameCauseId !== null && row.requestTypeId === this.sameCauseId;
    },
  },
};
</script>

<style scoped>
.ihist {
  overflow-x: auto;
  border: 1px solid var(--line);
  border-radius: 12px;
  background: #fff;
}
.ihist__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.95rem;
}
.ihist__table th {
  text-align: left;
  padding: 8px 12px;
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--ink-3);
  background: var(--mint-50);
  border-bottom: 1px solid var(--line);
  white-space: nowrap;
}
.ihist__table td {
  padding: 8px 12px;
  border-bottom: 1px solid var(--line-soft);
  vertical-align: middle;
}
.ihist__table tr:last-child td {
  border-bottom: 0;
}
.ihist__nr,
.ihist__date {
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
.ihist__table tr.is-same td {
  background: #fff7e8;
}
.ihist__table tr.is-same td:first-child {
  box-shadow: inset 4px 0 0 var(--amber);
}
.ihist__table tr.is-same .ihist__cause {
  font-weight: 700;
}
</style>
